/* eslint-disable prettier/prettier */
import * as gql from 'fake-tag';

export const ReviewsFragment = {
  Reviews: gql`
    fragment ReviewsQuery on reviews_Entry {
      backgroundImage {
        url
        ... on images_Asset {
          altText
        }
      }
      reviewTitle
      reviewType
      styles
      typeHandle
    }
  `,
};
